const APPROACH = "**Approach**";
const MAX_RATIONALE = 280;

/**
 * Makes a review card's context readable: the Approach section keeps only the newest entry per
 * decision (resubmissions repeat the same summary), and each rationale is cut to a short paragraph.
 * Everything outside the Approach section is left as it is.
 */
export function tidyContext(md: string): string {
  const start = md.indexOf(APPROACH);
  if (start === -1) return md;
  const bodyStart = start + APPROACH.length;
  const next = md.slice(bodyStart).search(/\n\n\*\*(?!Approach)[^*\n]+:?\*\*/);
  const end = next === -1 ? md.length : bodyStart + next;
  const section = md.slice(bodyStart, end);
  const items = section.split(/\n(?=- )/).map((s) => s.trim()).filter((s) => s.startsWith("- "));
  if (items.length === 0) return md;
  const byHead = new Map<string, string>();
  for (const item of items) {
    const [head, ...rest] = item.split("\n");
    byHead.delete(head!);
    byHead.set(head!, rest.join(" ").replace(/\s+/g, " ").trim());
  }
  const lines = [...byHead.entries()].slice(-2).map(([head, why]) => {
    if (!why) return head;
    const short = why.length > MAX_RATIONALE ? `${why.slice(0, MAX_RATIONALE).replace(/\s+\S*$/, "")}…` : why;
    return `${head}\n  ${short.replace(/[`*_]/g, "")}`;
  });
  return `${md.slice(0, bodyStart)}\n\n${lines.join("\n")}${md.slice(end)}`;
}
